<div fxFlex="grow">
    <div *ngIf="!data.isEdit">
        <appMetadataWidget [data]="data"></appMetadataWidget>
    </div>
    <div class="metadata-block">
        <div class="test-centinel">Test</div>
        <div class="form-name edit-icon-position">
            <input type="text" readonly fxFlex="flex-grow" class="form-name-field readonly-field" [(ngModel)]="data.name">
        </div>
        <div class="form-name" *ngIf="data.serviceCode">
            <div id="abc" class="metadata-key">Service Code</div>
            <div>
                <input type="text" readonly fxFlex="flex-grow" class="form-name-field readonly-field"
                    [(ngModel)]="data.serviceCode">
            </div>
        </div>
        <!-- <div class="form-name" *ngIf="data.data?.customerId">
            <div class="metadata-key">Customer </div>
            <div>
                <input type="text" readonly fxFlex="flex-grow" spellcheck="false" class="form-name-field readonly-field"
                    [(ngModel)]="data.data.customerId">
            </div>
        </div> -->
        <!-- Form Type {{ formType }} -->
        <ng-container *ngIf="formTypes$ | async as formTypes">
            <div *ngIf="!data.isEdit; else elseTypeBlock">
                <div class="metadata-key">Form Type</div>
                <div class="metadata-value">{{ getFormType(formTypes) }}</div>
            </div>
            <ng-template #elseTypeBlock>
                <div class="metadata-key" id="name-test">Form Type (Clic to change)</div>
                <mat-select class="metadata-value" [(ngModel)]="data.data.formTypeId">
                    <mat-option *ngFor="let formType of formTypes" [value]="formType.Id"
                        (onSelectionChange)="onSelect($event, formType.Id, formTypes)">{{formType.Name}}</mat-option>
                </mat-select>
            </ng-template>
        </ng-container>
    </div>
    <div class="metadata-block" *ngIf="data.version">
        <div *ngIf="data.version.StatusId">
            <div class="metadata-key" >Status</div>
            <appStatus [statusId]="data.version.StatusId" (click)="previewNavigate($event)"></appStatus>
            
        </div>
        <div *ngIf="data.lastUpdated">
            <div class="metadata-key">Last Modified Date</div>
            <div class="metadata-value">{{ data.lastUpdated | date:'MM/dd/yyyy h:mm a':'GMT' }}</div>
        </div>
        <div *ngIf="data.version.Createdby">
            <div class="metadata-key">Last Modified By</div>
            <div class="metadata-value">{{ data.version.Createdby}} ({{data.version.FirstName}}
                {{data.version.LastName}})</div>
        </div>
        <div *ngIf="data.version.Created">
            <div class="metadata-key">Created On</div>
            <div class="metadata-value">{{ data.version.Created | date:'MM/dd/yyyy h:mm a':'GMT'}}</div>
        </div>
        <div class="metadata-key">Form Version</div>
        <div *ngIf="data.version.Version">
            <div class="metadata-value">{{ data.version.Version }}</div>
        </div>
        <button class="button button--white button--small" routerLink="{{linkPreview}}" [queryParams]="{ id: data.dbId }">Preview Mode</button>
        <button *hasPermission="['FB_Dev_Forms']" class="button button--white button--small" (click)="downloadQuestions()">Download Questions</button>
        <span *ngIf="showEditFormBtn">
            <button *hasPermission="['FB_Admin_Forms']" class="button button--white button--small" (click)="openDialog()">
                <mat-icon class="update-icon">restore</mat-icon>
                Update Form</button>
        </span>
        
    </div>
</div>

<ng-template #createFormTemplateConfirmation>
    <form fxFlex="grow">
        <div class="dialog">
            <div class="dialog__title">Confirmation Message</div>
            <div class="dialog__body">
                <div class="dialog__icon">
                    <mat-icon>warning</mat-icon>
                </div>
                <div class="dialog__message">
                    <div><strong>You are about to create a new version of this form.</strong></div>
                    <div class="dialog__txt">Make this change if it is for the same customer. You can't add new customers with it. 
                    <br>   <br>
                        Click 'Confirm' if this is true.</div>
                    <br>
                </div>
            </div>
            <div class="dialog__footer">
                <button type="button" class="button button--white button--small" (click)="modalRefConf.hide();">Cancel</button>
                <button class="button button--small" (click)="createForm()">Confirm</button>
            </div>
        </div>
    </form>
  </ng-template>

  <ng-template #createFormTemplate>
    <div>
        <div class="dialog__title">Create A New Version</div>

        <div class="create-form">
            <div>
                <div>
                    <mat-label class="create-form-label no-margin">Form Name</mat-label>
                </div>
                <div class="input-icons pt-7">
                    <mat-icon matSuffix class="edit-icon-dialog">mode_edit</mat-icon>
                    <input disabled class="create-form-select pl-25" type="text" maxlength="35"
                        [(ngModel)]="data.name">
                </div>
            </div>
            <div>
                <div>
                    <mat-label class="create-form-label no-margin">Service Code</mat-label>
                </div>
                <div class="input-icons pt-7">
                    <input disabled class="create-form-select pl-25" type="text" maxlength="35"
                        [(ngModel)]="data.serviceCode">
                </div>
            </div>
    
            <div class="row form pt-28">
                <div class="col-md-4">
                    <input disabled id="newForm" type="radio" [checked]="!data.data.customerId"
                        class="new-form create-form-label">
                    <label class="pl-6" for="newForm">New Base Form</label>
                </div>
                <div class="col-md-7">
                    <div>
                        <input disabled id="customerForm" type="radio" [checked]="data.data.customerId"
                            class="customer-form create-form-label">
                        <label class="pl-6" for="customerForm">Customer Specific Form</label>
                    </div>
                    <!-- searchable select Customer -->
                    <div class="pt-7" fxLayout="column">
                            <input disabled class="create-form-select pl-25" type="text" maxlength="35"
                            [(ngModel)]="data.data.customerId">
                    </div>
                </div>
            </div>

        </div>
        <div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default reject-button"
                    (click)="modalRefConf.hide();">Cancel</button>
                <button type="button" (click)="createNewFormVersion()" class="btn btn-primary">Create A New Version</button>
            </div>
        </div>
    </div>
  </ng-template>